// EVENTS.VIEWS.APP.SETTINGS.COMPANY

export const COMPANY = {
  PAGE_VISITED: 'company_settings-page_visited',
  EDIT_PROFILE: 'company_profile-update_profile'
};
